


























import { Component, Prop, Vue } from 'vue-property-decorator';
import { WaterExport } from '@/api';
import ChangelogLink from '@/components/display/changelog-link.vue';
import { BvTableFieldArray } from 'bootstrap-vue';

@Component({
	components: { ChangelogLink },
})
export default class WaterConsentExportChangelogModal extends Vue {
	@Prop({ required: true })
	public modalId!: string;

	@Prop({ required: true })
	public waterExport!: WaterExport;

	protected readonly auditFields: BvTableFieldArray = [
		{ key: 'created_at', label: 'Date Sent' },
		{ key: 'event', label: 'Event' },
		{ key: 'from', label: 'From' },
		{ key: 'to', label: 'To' },
		{ key: 'user.name', label: 'By' },
	];
}
